module.exports = __webpack_public_path__ + "img/c65.f8690fcd.png";